import { useEffect } from 'react';
import './YunHeader.css';

import {
    cppMouseDown,
    cppMouseMove,
    cppMouseUp,
    cppWindowsAlawsOnTop,
    cppWindowsMinisize,
    cppCloseWindow,
} from '../../../api/cpp'

import { setUpdateTune } from "../../App/tools";

import { closeAccHelper } from "../AccHelper/tools";

import YunIcon from '../YunIcon/YunIcon'

import headerVipImg from './header_vip.png';

const defaultPng = require(`../../../static/default/logo.png`).default;

const YunHeader = (props) => {
    const { productInfo, sharpFlatState, emPlugsV3, handleSetIsTop, isTop=false, isAccHelper, } = props;
    useEffect(() => {
        cppWindowsAlawsOnTop(isTop)
    }, [isTop]);

    const handleMouseDown = (e) => {
        window.addEventListener('mousemove', mousemoveFun)
        window.addEventListener('mouseup', mouseupFun)
        cppMouseDown(e)
    }
    const mousemoveFun = (e)=> {
        cppMouseMove(e)
    }

    const mouseupFun = (e)=> {
        window.removeEventListener('mousemove', mousemoveFun)
        window.removeEventListener('mouseup', mouseupFun)
        cppMouseUp(e)
    }

    const clickQuitApp = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        if (props.handleClose) {
            props.handleClose()
        } else {
            cppWindowsMinisize()
            if (isAccHelper) {
                closeAccHelper()
            }
            if (sharpFlatState && sharpFlatState.online) {
                // 有升降调插件的情况下 退出前将升降调插件复原
                setUpdateTune(emPlugsV3, 0);
            }
            setTimeout(() => {
                cppCloseWindow();
            }, 1000);
        }
    }

    const clickOnTop = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        handleSetIsTop(!isTop)
        // cppWindowsAlawsOnTop(!isTop)
    }

    const clickMinWidow = (e) => {
        if (e.preventDefault) e.preventDefault()
        if (e.stopPropagation) e.stopPropagation()
        cppWindowsMinisize()
    }

    let rightEle = [];
    let leftEle = [];
    if (!props.hideOnTop) {
        rightEle.push(<div key="icon-ontop" className="iconBox clipBox" onClick={clickOnTop}><YunIcon iconClass="clip" icon={isTop ? 'clip-active' : 'clip'}></YunIcon></div>)
    }
    if (!props.hideMin) {
        rightEle.push(<div key="icon-min" className="iconBox" onClick={clickMinWidow}><YunIcon iconClass="min" icon="mini"></YunIcon></div>)
    }
    if (!props.hideQuit) {
        rightEle.push(<div key="icon-quit" className="iconBox quitBox" onClick={clickQuitApp}><YunIcon iconClass="quit" icon="close"></YunIcon></div>)
    }

    if (props.showVip) {
        leftEle.push(<img key="header-vip" className="vip" src={headerVipImg} alt="" />)
    }
    if (!props.hideLogo && !props.showVip) {
        leftEle.push(<img key="header-logo" className="logo" src={productInfo.png} onError={(e) => {e.target.src = defaultPng}} alt="-" />)
    }
    if (!props.hideTitle) {
        leftEle.push(<p key="header-title" className="FontSize11">{props.title || productInfo.title}</p>)
    }

    return (
        <div className="YunHeader" onMouseDown={handleMouseDown}>
            <div className="YunHeader-left">
                {leftEle}
            </div>
            <div className="YunHeader-right">
                {rightEle}
            </div>
        </div>
    )
}

export default YunHeader;
